/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ListaMenuMEL } from './listaMenuMEL';
import { ListaPreguntaMEL } from './listaPreguntaMEL';

export interface CrearUsuarioME { 
    avatarId?: number;
    tipoIdentificacionId?: number;
    identificacion?: string;
    nombre?: string;
    nombreUsuario?: string;
    contrasenia?: string;
    correo?: string;
    telefono?: string;
    preguntas?: Array<ListaPreguntaMEL>;
    menus?: Array<ListaMenuMEL>;
}